import { getApiRole } from "lib/general-helper.js";
import { stdevAndMean } from "lib/customMath.js";
import { useLocation } from "react-router-dom";

function cleanTierList(data) {
  let win_rates = {};
  let winRatesArray = data[0];
  const ban_rates = data[1];
  const last_updated_at = data[2];
  // const total_matches = data[3];
  let queue_type_total_matches = Math.round(data[3]);

  for (const [role, roleData] of Object.entries(winRatesArray)) {
    let role_array = [];
    roleData.forEach((champInfo) => {
      // champion_id, mini_bad_against, wins, matches, damage, gold, kills, assists, deaths, cs
      const bad_against_mini = champInfo[1];
      let bad_against = [];
      bad_against_mini.forEach((baddie) => {
        const new_baddie = {
          champion_id: baddie[0],
          wins: baddie[1],
          matches: baddie[2],
          win_rate: (1 - baddie[1] / baddie[2]) * 100,
          opp_win_rate: (baddie[1] / baddie[2]) * 100,
        };
        bad_against.push(new_baddie);
      });

      const champion_id = champInfo[0];

      const cur_champ_info = {
        champion_id,
        worst_against: {
          bad_against,
          champion_id,
          role,
        },
        wins: champInfo[2],
        matches: champInfo[3],
        damage: champInfo[4],
        gold: champInfo[5],
        kills: champInfo[6],
        assists: champInfo[7],
        deaths: champInfo[8],
        cs: champInfo[9],
      };

      const calc_info = {
        win_rate: (cur_champ_info.wins / cur_champ_info.matches) * 100,
        pick_rate: (cur_champ_info.matches / queue_type_total_matches) * 100,
        ban_rate: ban_rates[champion_id] ? (ban_rates[champion_id] / ban_rates["total_matches"]) * 100 : 0,
        avg_damage: cur_champ_info.damage / cur_champ_info.matches / 1000,
        avg_kda: (cur_champ_info.kills + cur_champ_info.assists) / cur_champ_info.deaths,
        avg_cs: cur_champ_info.cs / cur_champ_info.matches,
        avg_gold: cur_champ_info.gold / cur_champ_info.matches,
      };

      // let effective_win_rate =
      //   (calc_info.ban_rate / 100) * ((calc_info.win_rate / 100 + 0.55) / 2) +
      //   (calc_info.pick_rate / 100) * (calc_info.win_rate / 100) +
      //   (1 - calc_info.ban_rate / 100 - calc_info.pick_rate / 100) * 0.5;
      // effective_win_rate = effective_win_rate * 100;

      const champ_info = Object.assign({}, calc_info, {
        champion_id,
        role,
        champion_link: {
          champion_id,
          role,
        },
        worst_against: cur_champ_info["worst_against"],
        matches: cur_champ_info.matches,
        // effective_win_rate
      });

      role_array.push(champ_info);
    });

    // const effective_win_rates = role_array.map(x => x.effective_win_rate);
    //
    // let maths = stdevAndMean(effective_win_rates);

    // for (let i = 0; i < role_array.length; i++) {
    //   role_array[i]["tier"] = {
    //     pick_rate: role_array[i].pick_rate,
    //     stdevs: (role_array[i].effective_win_rate - maths.mean) / maths.stdev
    //   }
    // }

    let sorted_role_array = role_array.sort((a, b) => {
      // Sort by Win Rate
      return b.win_rate - a.win_rate;

      // Sort by Tier
      // if(a.tier.stdevs > b.tier.stdevs) {
      //   if(a.tier.pick_rate >= .5 && b.tier.pick_rate >= .5 ) return 1;
      //   else if(a.tier.pick_rate >= .5 && b.tier.pick_rate < .5 ) return 1;
      //   else if(a.tier.pick_rate < .5 && b.tier.pick_rate >= .5 ) return -1;
      //   else if(a.tier.pick_rate < .5 && b.tier.pick_rate < .5) {
      //     if(a.tier.stdevs > b.tier.stdevs) return 1;
      //     else if(a.tier.stdevs < b.tier.stdevs) return -1;
      //   }
      // }
      // else if(a.tier.stdevs < b.tier.stdevs) {
      //   if(a.tier.pick_rate >= .5 && b.tier.pick_rate >= .5 ) return -1;
      //   else if(a.tier.pick_rate >= .5 && b.tier.pick_rate < .5 ) return 1;
      //   else if(a.tier.pick_rate < .5 && b.tier.pick_rate >= .5 ) return -1;
      //   else if(a.tier.pick_rate < .5 && b.tier.pick_rate < .5) {
      //     if(a.tier.stdevs > b.tier.stdevs) return 1;
      //     else if(a.tier.stdevs < b.tier.stdevs) return -1;
      //   }
      // }
      // return 0
    });

    // sorted_role_array.reverse();
    win_rates[role] = sorted_role_array;
  }

  let pickRateMap = {};
  for (const [role, roleData] of Object.entries(win_rates)) {
    roleData.forEach((champion) => {
      if (pickRateMap[champion.champion_id]) {
        pickRateMap[champion.champion_id] += champion.pick_rate;
      } else {
        pickRateMap[champion.champion_id] = champion.pick_rate;
      }
    });
  }

  for (const [role, roleData] of Object.entries(win_rates)) {
    // console.log(role, roleData)
    roleData.forEach((champion) => {
      const { champion_id, ban_rate, pick_rate, win_rate } = champion;

      const total_pick_rate = pickRateMap[champion_id];
      const true_ban_rate = (pick_rate / total_pick_rate) * ban_rate;

      let effective_win_rate =
        win_rate >= 50
          ? (true_ban_rate / 100) * ((win_rate / 100 + 0.53) / 2) +
            (pick_rate / 100) * (win_rate / 100) +
            (1 - true_ban_rate / 100 - pick_rate / 100) * 0.5
          : (true_ban_rate / 100) * ((win_rate / 100 + 0.505) / 2) +
            (pick_rate / 100) * (win_rate / 100) +
            (1 - true_ban_rate / 100 - pick_rate / 100) * 0.5;
      effective_win_rate = effective_win_rate * 100;

      champion["effective_win_rate"] = effective_win_rate;
    });

    const effective_win_rates = roleData.map((x) => x.effective_win_rate);
    // console.log(effective_win_rates)
    const maths = stdevAndMean(effective_win_rates);
    for (let i = 0; i < roleData.length; i++) {
      roleData[i]["tier"] = {
        pick_rate: roleData[i].pick_rate,
        stdevs: (roleData[i].effective_win_rate - maths.mean) / maths.stdev,
      };
    }
    // console.log(roleData)
  }

  let all_roles_array = [];
  for (const [role, roleData] of Object.entries(win_rates)) {
    all_roles_array = all_roles_array.concat(roleData);
  }
  let sorted_roles_array = all_roles_array.sort((a, b) => {
    // Sort by Win Rate
    return b.win_rate - a.win_rate;
  });

  win_rates["all"] = sorted_roles_array;

  let ret_data = {
    win_rates,
    last_updated_at,
    total_matches: data[3],
    queue_type_total_matches: queue_type_total_matches,
  };

  return ret_data;
}

// const arrAvg = arr => arr.reduce((a, b) => a + b, 0) / arr.length;

// eventually need to refactor this code
function cleanChampionTableData(winRate, queueType, apiRole) {
  let cleaned = {};
  if (winRate) {
    if (queueType === "normal_aram" || queueType === "nexus_blitz") {
      cleaned.roleChampionWinRates = winRate.win_rates["none"];
      cleaned.totalMatchesCount = Math.floor(winRate.total_matches / 10);
    } else {
      cleaned.roleChampionWinRates = winRate.win_rates[apiRole];
      cleaned.totalMatchesCount = Math.floor(winRate.total_matches / 2);
    }
    cleaned.lastUpdated = winRate.last_updated_at;
  }

  return cleaned;
}

function getWinRatesIndex(params) {
  return `${[params.region, params.queueType, params.patch, params.rank].join("_")}`;
}

function selectWinRate(winRates, params) {
  let role_win_rates, last_updated, total_matches_count;

  if (!winRates) {
    return { role_win_rates, last_updated, total_matches_count };
  }

  let { queueType, role } = params;

  if (queueType === "normal_aram" || queueType === "nexus_blitz") {
    role = "none";
  } else {
    role = getApiRole(role);
  }

  role_win_rates = winRates.win_rates[role];
  last_updated = winRates.last_updated_at;
  total_matches_count = winRates.queue_type_total_matches;

  return { role_win_rates, last_updated, total_matches_count };
}

export { cleanTierList, cleanChampionTableData, selectWinRate, getWinRatesIndex };
